import React, { createContext, useContext, useMemo } from 'react';
const AddressAutofillContext = /*#__PURE__*/createContext(undefined);
export const AddressAutofillProvider = _ref => {
  let {
    children,
    onAddressSelect
  } = _ref;
  const value = useMemo(() => ({
    onAddressSelect
  }), [onAddressSelect]);
  return /*#__PURE__*/React.createElement(AddressAutofillContext.Provider, {
    value: value
  }, children);
};
export function useAddressAutofill() {
  var _useContext;
  return (_useContext = useContext(AddressAutofillContext)) == null ? void 0 : _useContext.onAddressSelect;
}
//# sourceMappingURL=address-autofill-context.js.map